import type { JSX } from "react";
import type { NavItemActionProps } from "./nav-item-action";
import type { NavItemExternalLinkProps } from "./nav-item-external-link";
import type { NavItemRouteProps } from "./nav-item-route";
import { usePermission } from "../../../../services/services-context";
import { NavItemAction } from "./nav-item-action";
import { NavItemExternalLink } from "./nav-item-external-link";
import { NavItemMenu, type NavItemMenuProps } from "./nav-item-menu/nav-item-menu"; // eslint-disable-line import/no-cycle
import { NavItemRoute } from "./nav-item-route";


export type NavItemProps = (
	| NavItemRouteProps
	| NavItemExternalLinkProps
	| NavItemActionProps
	| NavItemMenuProps
);

export const SingleNavItem = (props: NavItemProps): JSX.Element | null => {
	const permitted = usePermission(props.permissions);
	if(!permitted) {
		return null;
	}

	switch(props.kind) {
		case "route":
			return <NavItemRoute { ...props }/>;
		case "gaff":
			return <NavItemExternalLink { ...props }/>;
		case "action":
			return <NavItemAction { ...props }/>;
		case "menu":
			return <NavItemMenu { ...props }/>;
	}
};
